import { useEffect, useState } from 'react';
import styles from './styles.module.css';
import cn from 'classnames';

const ResourceShare = ({ isFacebook, isTwitter, isLinkedin, isEmail }) => {
  const [url, setUrl] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setUrl(window.location.href);
    }
  }, [isFacebook, isTwitter, isLinkedin, isEmail]);

  if (!url) return null;

  const networks = [
    { enabled: isFacebook, url: `https://www.facebook.com/sharer.php?u=${url}`, className: styles.facebook, label: 'Facebook' },
    { enabled: isTwitter, url: `https://twitter.com/share?url=${url}`, className: styles.twitter, label: 'Twitter' },
    { enabled: isLinkedin, url: `https://www.linkedin.com/shareArticle?url=${url}`, className: styles.linkedin, label: 'LinkedIn' },
    { enabled: isEmail, url: `mailto:?body=${url}`, className: styles.email, label: 'Email' }
  ];

  return (
    <div className={styles.resourceShare}>
      {networks.filter(net => net.enabled).map((net, index) => (
        <a key={index} href={net.url} className={cn(styles.link, net.className)} aria-label={net.label}>
          <span className={styles.visuallyHidden}>{net.label}</span>
        </a>
      ))}
    </div>
  );
};

export default ResourceShare;
